import React, {
    useState,
    useMemo,
  } from "react";

import {
    getSharingUrl,
    querySharingUrl,
  } from "../../../services/sports-api-service";

import CustomModal from "../../custommodal/CustomModal";

import {
    EmailShareButton,
    TelegramShareButton,
    TelegramIcon,
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    EmailIcon,
    } from "react-share";

import domtoimage from 'dom-to-image-more';

import { Helmet, HelmetProvider } from "react-helmet-async";

const fbHashtags = "#waldup #trailrunning #ultrarunning"
const twitterHashtags = ["waldup", "trailrunning", "ultrarunning"]

const ShareButtons = ({ id, activityDetails, userPrefUnits }) => {
    const [sharedLink, setSharedLink] = useState("/");
    const [error, setError] = useState(null);
    const [acceptedShare, setAcceptedShare] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [iconSize, setIconSize] = useState(33);
    const [shareTitle, setShareTitle] = useState(null);
    const [shareDescription, setShareDescription] = useState(null);

    const [shareImage, setShareImage] = useState(null);

    /* useMemo(() => {
      const pdfCanvas = document.getElementById("elevationGraphWrapper");
      if (pdfCanvas) {
        domtoimage.toPng(pdfCanvas)
        .then(function (dataUrl) {
          var img = new Image(300);
          img.src = dataUrl;
          setShareImage(img);
          //TODO: post image back to server and get back a url
        })
        .catch(function (error) {
          console.error("could not generate share image: ", error);
        });
      }
    }, [activityDetails]); */

    const closeModalHandler = () => {
        setShowModal(false);
      };
    
    const handleActivityShare = () => {
        setShowModal(true);
      };

    const title = useMemo(() => {
      if (activityDetails.title && activityDetails.totalDistanceRounded && activityDetails.totalPositiveElevationRounded) {
        const newTitle = `Check out [${activityDetails.title}]: A fully interactive ${activityDetails.totalDistanceRounded}${userPrefUnits[1]} activity featuring ${activityDetails.totalPositiveElevationRounded}${userPrefUnits[2]} of elevation gain.`;
        return newTitle;
      }
      else {
        const dumbTitle = "Check out my activity on Waldup.com";
        return dumbTitle;
      }
    }, [activityDetails, userPrefUnits]);

    const description = useMemo(() => {
      if (activityDetails.description && activityDetails.description.startsWith("Track: ")) {
        const patternTrackName = /^Track:\s+(.+\.gpx)/i;
        const trackName = activityDetails.description.match(patternTrackName)[1];
        // We assume we have computed generated description, so we add some color to it
        const newDescription = `[${activityDetails.title}] is a is a fully interactive, customisable activity created with Waldup.com.
        It uses the track named ${trackName}, which is ${activityDetails.totalDistanceRounded}${userPrefUnits[1]} long and has ${activityDetails.totalPositiveElevationRounded}${userPrefUnits[2]} of elevation.
        Sign up now and start using Waldup for Free`;
        return newDescription;
      }
      else if (activityDetails.description) {
        const newDescription = `${activityDetails.description}. This fully interactive plan has been created using Waldup.com Sign up now and start using it for Free`;
        return newDescription;
      }
      else {
        const dumbDescription = "From a GPX Track to your fully interactive plan in less than 1 minute. Use Waldup to automate and improve your trail & ultra running planning, so you can spend more time running.";
        return dumbDescription;
      }
    }, [activityDetails, userPrefUnits]);        

    useMemo(() => {
      if (activityDetails !== null) {
        setShareTitle(title);
        setShareDescription(description);    
  
        if (activityDetails.share_type === "public") {
          setAcceptedShare(true);
          querySharingUrl(id)
            .then(async (res) => {
              if (!res.ok) {
                const error = await res.json();
                setError(error);
                throw error;
              } else {
                return res.json();
              }
            })
            .then((res) => {
              setSharedLink(res.url);
            })
            .catch((error) => {
              console.log(error);
            });
        }
        else if (activityDetails.share_type === "private") {
          setAcceptedShare(false);
        }
      }
    }, [activityDetails, id, title]);
      
    const confirmShared = () => {
        !acceptedShare ? handleActivityShare() : (() => {})();
      };
    
    let askForPermission = !acceptedShare ? confirmShared : null;

    const shareModalDataPayload = {
      btnOkCb: () => {
        setAcceptedShare(true);
        getSharingUrl(id)
          .then(async (res) => {
            if (!res.ok) {
              const error = await res.json();
              setError(error);
              throw error;
            } else {
              return res.json();
            }
          })
          .then((res) => {
            setSharedLink(res.url);
          })
          .catch((error) => {
            console.log(error);
          });

        setShowModal(false);
        },
      bodyText:
      "You are going to make this activity available to the public. Anyone with the link can access it.",
  };
    
  return (
    <div className='sharing-buttons'>
        <HelmetProvider>
          <Helmet>
              <title>Waldup.com - {shareTitle ? shareTitle : ""} - Trail & Ultra Running Planning Made Easy</title>
              <meta property="og:site_name" content="Waldup.com" />
              <meta property="og:title" content={shareTitle ? shareTitle : ""}/>
              <meta property="og:description" content={shareDescription ? shareDescription : ""}/>
              {/* I need the address to the image, not the actual image */}
              <meta property="og:image" itemprop="image" content="https://waldup.com/static/images/email_desc_1.png"/>
              <meta property="og:image:type" content="image/png"/>
              <meta property="og:type" content="website" />
              <meta name="twitter:title" content={shareTitle}/>
              <meta name="twitter:image" content="https://waldup.com/static/images/email_desc_1.png"/>
              <meta name="twitter:description" content={shareDescription}/>
          </Helmet>
        </HelmetProvider>
      {showModal && 
        <CustomModal
        payload={shareModalDataPayload}
        showModal={showModal}
        closeModalHandler={closeModalHandler}
        />}
      {!acceptedShare && (<div
          title="Share activity"
          className="btn btn-light control-button"
          onClick={askForPermission}>
          <i className="fas fa-share-square"></i>
              Share
      </div>)}
      {acceptedShare && shareTitle && (
      <div>
        <FacebookShareButton 
          disabled={!acceptedShare}
          url={sharedLink}
          hashtag={fbHashtags}
          quote={shareTitle}
          >
        <FacebookIcon size={iconSize} round />
        </FacebookShareButton>
        <TwitterShareButton 
          disabled={!acceptedShare} 
          url={sharedLink}
          hashtags={twitterHashtags}
          title={shareTitle}>
        <TwitterIcon size={iconSize} round />
        </TwitterShareButton>
        <WhatsappShareButton disabled={!acceptedShare} url={sharedLink} title={shareTitle}>
        <WhatsappIcon size={iconSize} round />
        </WhatsappShareButton>
        <TelegramShareButton disabled={!acceptedShare} url={sharedLink}>
        <TelegramIcon size={iconSize} round />
        </TelegramShareButton>
        <EmailShareButton disabled={!acceptedShare} url={sharedLink} subject={"Check this activity on Waldup.com"} 
        body={"Hey, Check this activity I created on waldup.com."}>
        <EmailIcon size={iconSize} round />
        </EmailShareButton>
      </div>)}
    </div>
  );
};
    
export default ShareButtons;